<template>
  <el-dialog draggable v-model="showProxy" fullscreen @confirm="onConfirm" @cancel="handleClose"
    :before-close="handleClose" class="view-topo-modal dialog-container">
    <template #header>
      <div class="header-container">
        <!-- <div class="icon-container"></div> -->
        <span class="title-text">{{ props.operateType == 'add' ? $str.getKey('数据分析/添加虚拟电表') : $str.getKey('数据分析/编辑虚拟电表')
        }}</span>
      </div>
    </template>

    <div class="modal-container">
      <div class="edit-container">
        <div class="name-container">
          <div class="item-label"><span class="xing-symbol">*</span>{{ $str.getKey('数据分析/虚拟电表名称') }}:</div>
          <el-input class="item-input" :placeholder="$str.getKey('数据分析/请输入虚拟电表名称')" v-model="formData.meterName" />
        </div>
        <div class="select-meter-container">
          <div class="item-label"><span class="xing-symbol">*</span>{{ $str.getKey('数据分析/虚拟电表取值') }}:</div>
          <el-select class="item-select" :placeholder="$str.getKey('数据分析/请选择电表')" v-model="formData.curMeterId">
            <el-option :value="mt.uuid" v-for="mt in formData.meterList" :label="mt.meterName"></el-option>
          </el-select>
          <el-button class="add-btn" @click="addMeter" :icon="Plus" plain></el-button>
          <el-button class="sub-btn" @click="subMeter" :icon="Minus" plain></el-button>
        </div>
        <div class="meters-container">
          <div class="add-container">
            <div class="title-container add"><span class="text">{{ $str.getKey('数据分析/加项') }}</span></div>
            <el-scrollbar height="100%" class="scrollbar-container">
              <div class="meter-list">
                <div v-if="formData.addList.length === 0" class="empty-state">{{ $str.getKey('数据分析/暂无数据') }}</div>
                <div class="meter-item" v-for="(meter, idx) in formData.addList" :key="meter.uuid">
                  <div class="item-name">
                    <span>{{ meter.meterName }}</span>
                    <span>({{ meter.uuid }})</span>
                  </div>
                  <div class="item-btns">
                    <el-icon class="delete-btn" @click="deleteMeter('addList', idx, meter)">
                      <Delete />
                    </el-icon>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="sub-container">
            <div class="title-container sub"><span class="text">{{ $str.getKey('数据分析/减项') }}</span></div>
            <el-scrollbar height="100%" class="scrollbar-container">
              <div class="meter-list">
                <div v-if="formData.subList.length === 0" class="empty-state">{{ $str.getKey('数据分析/暂无数据') }}</div>
                <div class="meter-item" v-for="(meter, idx) in formData.subList" :key="meter.uuid">
                  <div class="item-name">
                    <span>{{ meter.meterName }}</span>
                    <span>({{ meter.uuid }})</span>
                  </div>
                  <div class="item-btns">
                    <el-icon class="delete-btn" @click="deleteMeter('subList', idx, meter)">
                      <Delete />
                    </el-icon>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>

      </div>
      <div class="topo-graph-container">
        <TopoGraph></TopoGraph>
      </div>
    </div>

    <template #footer>
      <el-button @click="handleClose" class="custom-cancel-btn">{{ $str.getKey('数据分析/取消') }}</el-button>
      <el-button type="primary" @click="onConfirm" class="custom-confirm-btn" :disabled="isConfirming">{{
        $str.getKey('数据分析/确定') }}</el-button>
    </template>
  </el-dialog>

</template>
<script setup>
import { defineEmits, defineOptions, defineProps, reactive, ref, computed } from "vue";
import { useVModel } from "@vueuse/core";
import { meterApi } from "@/api/modules/device/index.js";
import { v2 as apiV2 } from "@/api/modules/station/index.js";
import { Plus, Minus, Delete } from '@element-plus/icons-vue'
import TopoGraph from "./topoGraph/index.vue"; // 拓扑图
import { useAppStore } from "@/store/modules/app";

const $str = window.$str;
const stationId = computed(() => {
  return useAppStore().stationId
})

/** 设置组件配置项 */
defineOptions({
  name: "AddVirtualMeterModal"
});

/** 接收父组件信息 */
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  operateType: {
    type: String,
    default: ''
  },
  vMeterId: {
    type: String,
    default: ''
  },
});

const emit = defineEmits(['update:show', 'SendChange', 'updateVirtualMeter']);
const showProxy = useVModel(props, "show", emit);
const formData = reactive({
  meterName: '', // 新增的虚拟电表名称
  curMeterId: '', // 当前选中的电表
  meterList: [], // 选择电表的下拉选项
  addList: [],
  subList: [],
})
const isConfirming = ref(false);


/** 添加电表【加项】 */
function addMeter() {
  if (formData.curMeterId) {
    const curMeter = formData.meterList.find(it => it.uuid == formData.curMeterId);
    if (curMeter) { formData.addList.push(curMeter); }
  }
}

/** 添加电表【减项】 */
function subMeter() {
  if (formData.curMeterId) {
    const curMeter = formData.meterList.find(it => it.uuid == formData.curMeterId);
    if (curMeter) { formData.subList.push(curMeter); }
  }
}

/** 删除电表【加项or减项】 */
function deleteMeter(key, idx, meter) {
  const list = formData[key]; // 从formData获取要操作的addList|subList
  list.splice(idx, 1)
}

function initPage() {
  if (props.vMeterId) {
    getVirtualMeterById(props.vMeterId);
  }
  getMeterList();
}
initPage();
function handleClose() { emit("SendChange", false); }
function updateDeviceList(msg) { emit("updateVirtualMeter", msg); }

function onConfirm() {
  // 校验名称
  if (formData.meterName.trim() == '') {
    window.dispatchNotify({
      type: 'error',
      message: $str.getKey('数据分析/请输入虚拟电表名称')
    })
    return false;
  }
  // 检验添加的电表项
  if (formData.addList.length < 1) {
    window.dispatchNotify({
      type: 'error',
      message: $str.getKey('数据分析/请至少添加一个需要加的电表')
    })
    return false;
  }
  // 入库
  if (props.operateType == 'add') {
    isConfirming.value = true;
    addVirtualMeter();
  }
  if (props.operateType == 'edit') {
    isConfirming.value = true;
    updateVirtualMeter();
  }
}



/** ======【功能方法】============================================================================= */

/** 获取可选电表的下拉选项 */
function getMeterList() {
  return apiV2.getDevicesByIdV2(stationId.value).then(res => {
    if (res?.data?.outerMeters && Array.isArray(res.data.outerMeters)) {
      formData.meterList = res.data.outerMeters;
    }
  });
}

/** 入库：添加虚拟电表 */
function addVirtualMeter() {
  const addList = formData.addList.map(meter => {
    return { uuid: meter.uuid, meterName: meter.meterName }
  })
  const subList = formData.subList.map(meter => {
    return { uuid: meter.uuid, meterName: meter.meterName }
  })
  meterApi.postVMeter(stationId.value, formData.meterName, addList, subList).then(res => {
    if (res?.code == 200) {
      window.dispatchNotify({
        type: 'success',
        message: $str.getKey('数据分析/添加成功')
      })
      updateDeviceList('add');
    }
  }).catch(err => {
    console.error('虚拟电表添加失败：', err)
    window.dispatchNotify({
      type: 'error',
      message: $str.getKey('数据分析/添加失败')
    })
  }).finally(() => {
    isConfirming.value = false;
    handleClose();
  })
}

/** 入库：更新虚拟电表 */
function updateVirtualMeter() {
  const addList = formData.addList.map(meter => {
    return { uuid: meter.uuid, meterName: meter.meterName }
  })
  const subList = formData.subList.map(meter => {
    return { uuid: meter.uuid, meterName: meter.meterName }
  })
  meterApi.putVMeter(props.vMeterId, stationId.value, formData.meterName, addList, subList).then(res => {
    if (res?.code == 200) {
      window.dispatchNotify({
        type: 'success',
        message: $str.getKey('数据分析/更新成功')
      })
      updateDeviceList('update');
    }
  }).catch(err => {
    console.error('虚拟电表添加失败：', err)
    window.dispatchNotify({
      type: 'error',
      message: $str.getKey('数据分析/更新失败')
    })
  }).finally(() => {
    isConfirming.value = false;
    handleClose();
  })
}

/** 获取被编辑的虚拟电表的数据 */
function getVirtualMeterById(virtualMeterId) {
  meterApi.getVMeterList(stationId.value).then(res => {
    if (res?.rows && Array.isArray(res.rows)) {
      const curMeter = res.rows.find(it => it.uuid == virtualMeterId || it.id == virtualMeterId);
      formData.meterName = curMeter.meterName ?? '';
      formData.addList = curMeter.addList ?? [];
      formData.subList = curMeter.subList ?? [];
      formData.curMeterId = '';
    }
  })
}
</script>




<style lang="scss" scoped>
.view-topo-modal {
  .header-container {
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 50px;

    .icon-container {
      width: 29px;
      height: 29px;
      background-image: radial-gradient(#FFF 5%, #3a68ff 30%);
      border-radius: 4px;
      border: 1px solid #3a68ff;
      transform: rotate(45deg);
      margin-right: 20px;
    }

    .title-text {
      font-family: 'HarmonyOS Sans SC', sans-serif;
      font-size: 18px;
      font-weight: 500;
      color: #2e2e2e;
      text-align: center;
      letter-spacing: 1px;
    }
  }

  .modal-container {
    height: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-sizing: border-box;

    .edit-container {
      display: flex;
      flex-direction: column;
      gap: 20px;
      flex-shrink: 0;

      .name-container,
      .select-meter-container {
        display: flex;
        align-items: center;
        gap: 16px;

        .item-label {
          min-width: 120px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(46, 46, 46, 0.85);
          display: flex;
          align-items: center;
          white-space: nowrap;

          .xing-symbol {
            color: #F56C6C;
            margin-right: 4px;
            font-size: 14px;
          }
        }

        .item-input {
          flex: 1;
          max-width: 300px;

          :deep(.el-input__wrapper) {
            border-radius: 8px;
            border: 1px solid rgba(192, 207, 218, 0.3);
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

            &:hover {
              border-color: rgba(192, 207, 218, 0.5);
            }

            &.is-focus {
              border-color: #3a68ff;
            }
          }
        }

        .item-select {
          flex: 1;
          max-width: 300px;

          :deep(.el-input__wrapper) {
            border-radius: 8px;
            border: 1px solid rgba(192, 207, 218, 0.3);
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

            &:hover {
              border-color: rgba(192, 207, 218, 0.5);
            }

            &.is-focus {
              border-color: #3a68ff;
            }
          }
        }

        .add-btn {
          background: #3a68ff;
          border-radius: 8px;
          color: #FFFFFF;
          font-size: 18px;
          border: none;
          width: 40px;
          height: 40px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 12px;
          transition: all 0.2s;

          &:hover {
            background: #2d5aef;
            box-shadow: 0 2px 8px rgba(58, 104, 255, 0.3);
            transform: translateY(-1px);
          }

          &:active {
            transform: translateY(0);
          }
        }

        .sub-btn {
          background: #F56C6C;
          border-radius: 8px;
          color: #FFFFFF;
          font-size: 18px;
          border: none;
          width: 40px;
          height: 40px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 8px;
          transition: all 0.2s;

          &:hover {
            background: #E45656;
            box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
            transform: translateY(-1px);
          }

          &:active {
            transform: translateY(0);
          }
        }
      }

      .meters-container {
        display: flex;
        gap: 20px;
        min-height: 240px;

        .add-container,
        .sub-container {
          height: 240px;
          flex: 1;
          box-sizing: border-box;
          background: #FFFFFF;
          border: 1px solid rgba(192, 207, 218, 0.3);
          border-radius: 12px;
          display: flex;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

          .title-container {
            width: 48px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            writing-mode: vertical-rl;
            text-orientation: mixed;
            flex-shrink: 0;

            &.add {
              background: linear-gradient(180deg, #536BFA 0%, #3a68ff 100%);
            }

            &.sub {
              background: linear-gradient(180deg, #F56C6C 0%, #E45656 100%);
            }

            .text {
              font-size: 14px;
              font-weight: 600;
              color: #FFFFFF;
              letter-spacing: 2px;
              white-space: nowrap;
            }
          }

          .scrollbar-container {
            flex: 1;
            width: 100%;

            :deep(.el-scrollbar__bar) {
              &.is-vertical {
                right: 4px;
              }
            }
          }

          .meter-list {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 16px;
            gap: 12px;
            min-height: 100%;

            .empty-state {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              color: rgba(46, 46, 46, 0.4);
              font-size: 14px;
              min-height: 200px;
            }

            .meter-item {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 12px 16px;
              background: rgba(255, 255, 255, 1);
              border-radius: 8px;
              border: 1px solid rgba(192, 207, 218, 0.3);
              transition: all 0.2s;

              &:hover {
                border-color: rgba(58, 104, 255, 0.3);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
                transform: translateY(-1px);
              }

              .item-name {
                font-size: 14px;
                color: rgba(46, 46, 46, 0.85);
                display: flex;
                flex-direction: column;
                gap: 4px;
                flex: 1;

                span:first-child {
                  font-weight: 500;
                  color: rgba(46, 46, 46, 1);
                }

                span:last-child {
                  font-size: 12px;
                  color: rgba(46, 46, 46, 0.5);
                  font-family: 'Courier New', monospace;
                }
              }

              .item-btns {
                flex-shrink: 0;
                margin-left: 12px;

                .delete-btn {
                  width: 32px;
                  height: 32px;
                  background: #F56C6C;
                  border-radius: 6px;
                  border: none;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #FFFFFF;
                  font-size: 16px;
                  transition: all 0.2s;

                  &:hover {
                    background: #E45656;
                    box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
                    transform: scale(1.05);
                  }

                  &:active {
                    transform: scale(0.95);
                  }
                }
              }
            }

            // 空状态通过模板中的元素显示，不使用CSS content
          }
        }
      }

    }

    .topo-graph-container {
      height: 0;
      flex: 1;
      min-height: 300px;
      box-sizing: border-box;
      background: #FFFFFF;
      border: 1px solid rgba(192, 207, 218, 0.3);
      border-radius: 12px;
      overflow: hidden;
      padding: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }
  }

  .custom-confirm-btn {
    font-family: "HarmonyOS Sans SC", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    background: #3a68ff !important;
    color: #fff !important;

    &:hover {
      background: #3a68ff !important;
      opacity: 0.9;
    }

    &:active {
      background: #3a68ff !important;
      opacity: 0.8;
    }
  }

  .custom-cancel-btn {
    border: 1px solid rgba(192, 207, 218, 0.3) !important;

    &:hover {
      background: #f5f7fa !important;
      color: #2e2e2e !important;
    }

    &:active {
      background: #f5f7fa !important;
    }
  }

  // 底部按钮样式优化
  :deep(.el-dialog__footer) {
    padding: 16px 24px;
    border-top: 1px solid rgba(192, 207, 218, 0.2);
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .el-button {
      min-width: 98px;
      height: 40px;
      border-radius: 8px;
      font-family: 'HarmonyOS Sans SC', sans-serif;
      font-size: 14px;
      transition: all 0.2s;

      &:not(.el-button--primary) {
        border: 1px solid rgba(192, 207, 218, 0.3);
        color: rgba(46, 46, 46, 0.85);
        background: #FFFFFF;

        &:hover {
          border-color: rgba(192, 207, 218, 0.5);
          background: #f5f7fa;
        }
      }

      &.el-button--primary {
        background: #3a68ff;
        border: none;

        &:hover {
          background: #2d5aef;
          box-shadow: 0 2px 8px rgba(58, 104, 255, 0.3);
        }

        &:disabled {
          background: rgba(58, 104, 255, 0.5);
          cursor: not-allowed;
        }
      }
    }
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .modal-container {
      padding: 16px;

      .edit-container {
        gap: 16px;

        .name-container,
        .select-meter-container {
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;

          .item-label {
            min-width: auto;
          }

          .item-input,
          .item-select {
            max-width: none;
            width: 100%;
          }

          .add-btn,
          .sub-btn {
            align-self: flex-end;
            margin-left: 0;
          }
        }

        .meters-container {
          flex-direction: column;
          gap: 16px;

          .add-container,
          .sub-container {
            height: 180px;
          }
        }
      }

      .topo-graph-container {
        min-height: 200px;
      }
    }
  }
}
</style>
